import { InjectionToken, Injectable, NgZone, Inject, PLATFORM_ID, EventEmitter, Directive, Input, Output, ElementRef, Self, Component, ChangeDetectionStrategy, ViewChild, NgModule, ɵɵdefineInjectable, ɵɵinject } from '@angular/core';
import { isPlatformServer, DOCUMENT, CommonModule } from '@angular/common';
import { from, throwError, of, Subject } from 'rxjs';
import { map, catchError, shareReplay, takeUntil } from 'rxjs/operators';
import { makeStateKey, TransferState } from '@angular/platform-browser';

/**
 * @fileoverview added by tsickle
 * Generated from: src/utils.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @param {?} animation
 * @return {?}
 */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';
import * as ɵngcc2 from '@angular/platform-browser';

const _c0 = ["container"];
function transformAnimationFilenameToKey(animation) {
    return `animation-${animation.split('.json')[0]}`;
}
/**
 * @param {?} player
 * @param {?} href
 * @param {?} isSafari
 * @return {?}
 */
function setPlayerLocationHref(player, href, isSafari) {
    // This is a fix for the mask on Safari/iOS
    // https://github.com/airbnb/lottie-web/issues/1198
    if (isSafari) {
        ((/** @type {?} */ (((/** @type {?} */ (player)))))).setLocationHref(href);
    }
}
/**
 * @param {?} options
 * @param {?} container
 * @param {?} animationCache
 * @return {?}
 */
function mergeOptionsWithDefault(options, container, animationCache) {
    /** @type {?} */
    const merged = Object.assign({
        container,
        renderer: 'svg',
        loop: true,
        autoplay: true
    }, options);
    if (animationCache !== null) {
        return animationCache.transformOptions(merged);
    }
    return merged;
}
/**
 * @return {?}
 */
function isSafariFactory() {
    // This `try-catch` block will also handle server-side rendering
    // as `navigator` is not accessable there
    try {
        const { vendor, userAgent } = navigator;
        return (vendor.indexOf('Apple') > -1 &&
            userAgent.indexOf('CriOS') === -1 &&
            userAgent.indexOf('FxiOS') === -1);
    }
    catch (_a) {
        return false;
    }
}
/**
 * @param {?} options
 * @return {?}
 */
function isAnimationConfigWithData(options) {
    /** @type {?} */
    const animationData = ((/** @type {?} */ (options))).animationData;
    return animationData !== null && typeof animationData === 'object';
}
/**
 * @param {?} animationCache
 * @param {?} options
 * @param {?} animationItem
 * @return {?}
 */
function awaitConfigAndCache(animationCache, options, animationItem) {
    if (animationCache === null) {
        return;
    }
    animationItem.addEventListener('config_ready', (/**
     * @return {?}
     */
    () => {
        animationCache.set(options, animationItem);
    }));
}
/**
 * @param {?} player
 * @return {?}
 */
function streamifyPlayerOrLoader(player) {
    /** @type {?} */
    const playerOrLoader = player();
    if (playerOrLoader instanceof Promise) {
        return from(playerOrLoader).pipe(map((/**
         * @param {?} module
         * @return {?}
         */
        module => module.default || module)), catchError((/**
         * @param {?} error
         * @return {?}
         */
        error => {
            console.error(`
          Could not retrieve the "lottie-web" player, did you provide
          the "player" property correctly?
          export function playerFactory() {
            return import('lottie-web');
          }
          LottieModule.forRoot({ player: playerFactory })
        `);
            return throwError(error);
        })), shareReplay(1));
    }
    return of(playerOrLoader);
}

/**
 * @fileoverview added by tsickle
 * Generated from: src/symbols.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function BMEnterFrameEvent() { }
if (false) {
    /** @type {?} */
    BMEnterFrameEvent.prototype.currentTime;
    /** @type {?} */
    BMEnterFrameEvent.prototype.duration;
    /** @type {?} */
    BMEnterFrameEvent.prototype.totalTime;
    /** @type {?} */
    BMEnterFrameEvent.prototype.type;
}
/**
 * @record
 */
function BMCompleteLoopEvent() { }
if (false) {
    /** @type {?} */
    BMCompleteLoopEvent.prototype.type;
    /** @type {?} */
    BMCompleteLoopEvent.prototype.loop;
    /** @type {?} */
    BMCompleteLoopEvent.prototype.playCount;
    /** @type {?} */
    BMCompleteLoopEvent.prototype.frameMult;
}
/**
 * @record
 */
function BMCompleteEvent() { }
if (false) {
    /** @type {?} */
    BMCompleteEvent.prototype.type;
    /** @type {?} */
    BMCompleteEvent.prototype.duration;
}
/**
 * @record
 */
function BMSegmentStartEvent() { }
if (false) {
    /** @type {?} */
    BMSegmentStartEvent.prototype.type;
    /** @type {?} */
    BMSegmentStartEvent.prototype.firstFrame;
    /** @type {?} */
    BMSegmentStartEvent.prototype.totalFrames;
}
/**
 * @record
 */
function BMDestroyEvent() { }
if (false) {
    /** @type {?} */
    BMDestroyEvent.prototype.target;
    /** @type {?} */
    BMDestroyEvent.prototype.type;
}
/**
 * @record
 */
function BMRenderFrameErrorEvent() { }
if (false) {
    /** @type {?} */
    BMRenderFrameErrorEvent.prototype.type;
    /** @type {?} */
    BMRenderFrameErrorEvent.prototype.nativeError;
    /** @type {?} */
    BMRenderFrameErrorEvent.prototype.currentTime;
}
/**
 * @record
 */
function BMConfigErrorEvent() { }
if (false) {
    /** @type {?} */
    BMConfigErrorEvent.prototype.type;
    /** @type {?} */
    BMConfigErrorEvent.prototype.nativeError;
}
/**
 * @record
 */
function LottieOptions() { }
if (false) {
    /** @type {?} */
    LottieOptions.prototype.player;
    /** @type {?|undefined} */
    LottieOptions.prototype.useCache;
}
/** @type {?} */
const IS_SAFARI = new InjectionToken('IsSafari');
/** @type {?} */
const LOTTIE_OPTIONS = new InjectionToken('LottieOptions');
/** @type {?} */
const ANIMATION_CACHE = new InjectionToken('AnimationCache');

/**
 * @fileoverview added by tsickle
 * Generated from: src/animation-loader.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
// This has to be dynamic as `Document` interface is not
// accepted by the ngc compiler
// @dynamic
class AnimationLoader {
    /**
     * @param {?} ngZone
     * @param {?} platformId
     * @param {?} document
     * @param {?} isSafari
     * @param {?} options
     * @param {?} animationCache
     */
    constructor(ngZone, platformId, document, isSafari, options, animationCache) {
        this.ngZone = ngZone;
        this.platformId = platformId;
        this.document = document;
        this.isSafari = isSafari;
        this.options = options;
        this.animationCache = animationCache;
        this.player$ = streamifyPlayerOrLoader(this.options.player);
    }
    /**
     * @param {?} options
     * @param {?} container
     * @param {?} eventsFacade
     * @param {?} animationCreated
     * @param {?} instance
     * @param {?} destroy$
     * @return {?}
     */
    resolveLoaderAndLoadAnimation(options, container, eventsFacade, animationCreated, instance, destroy$) {
        if (isPlatformServer(this.platformId)) {
            return;
        }
        this.player$.pipe(takeUntil(destroy$)).subscribe((/**
         * @param {?} player
         * @return {?}
         */
        player => {
            /** @type {?} */
            const mergedOptions = mergeOptionsWithDefault(options, container, this.animationCache);
            this.loadAnimation(player, mergedOptions, eventsFacade, animationCreated, instance);
        }));
    }
    /**
     * @private
     * @param {?} player
     * @param {?} options
     * @param {?} eventsFacade
     * @param {?} animationCreated
     * @param {?} instance
     * @return {?}
     */
    loadAnimation(player, options, eventsFacade, animationCreated, instance) {
        setPlayerLocationHref(player, this.document.location.href, this.isSafari);
        /** @type {?} */
        const animationItem = this.ngZone.runOutsideAngular((/**
         * @return {?}
         */
        () => player.loadAnimation(options)));
        awaitConfigAndCache(this.animationCache, options, animationItem);
        // Dispatch `animationCreated` event after animation is loaded successfully
        animationCreated.emit(animationItem);
        eventsFacade.addEventListeners(instance, animationItem);
    }
}
AnimationLoader.ɵfac = function AnimationLoader_Factory(t) { return new (t || AnimationLoader)(ɵngcc0.ɵɵinject(ɵngcc0.NgZone), ɵngcc0.ɵɵinject(PLATFORM_ID), ɵngcc0.ɵɵinject(DOCUMENT), ɵngcc0.ɵɵinject(IS_SAFARI), ɵngcc0.ɵɵinject(LOTTIE_OPTIONS), ɵngcc0.ɵɵinject(ANIMATION_CACHE)); };
AnimationLoader.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: AnimationLoader, factory: AnimationLoader.ɵfac });
/** @nocollapse */
AnimationLoader.ctorParameters = () => [
    { type: NgZone },
    { type: String, decorators: [{ type: Inject, args: [PLATFORM_ID,] }] },
    { type: Document, decorators: [{ type: Inject, args: [DOCUMENT,] }] },
    { type: Boolean, decorators: [{ type: Inject, args: [IS_SAFARI,] }] },
    { type: undefined, decorators: [{ type: Inject, args: [LOTTIE_OPTIONS,] }] },
    { type: undefined, decorators: [{ type: Inject, args: [ANIMATION_CACHE,] }] }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AnimationLoader, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc0.NgZone }, { type: String, decorators: [{
                type: Inject,
                args: [PLATFORM_ID]
            }] }, { type: Document, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }, { type: Boolean, decorators: [{
                type: Inject,
                args: [IS_SAFARI]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [LOTTIE_OPTIONS]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [ANIMATION_CACHE]
            }] }]; }, null); })();
if (false) {
    /**
     * @type {?}
     * @private
     */
    AnimationLoader.prototype.player$;
    /**
     * @type {?}
     * @private
     */
    AnimationLoader.prototype.ngZone;
    /**
     * @type {?}
     * @private
     */
    AnimationLoader.prototype.platformId;
    /**
     * @type {?}
     * @private
     */
    AnimationLoader.prototype.document;
    /**
     * @type {?}
     * @private
     */
    AnimationLoader.prototype.isSafari;
    /**
     * @type {?}
     * @private
     */
    AnimationLoader.prototype.options;
    /**
     * @type {?}
     * @private
     */
    AnimationLoader.prototype.animationCache;
}

/**
 * @fileoverview added by tsickle
 * Generated from: src/base.directive.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class BaseDirective {
    /**
     * @param {?} platformId
     * @param {?} animationLoader
     */
    constructor(platformId, animationLoader) {
        this.platformId = platformId;
        this.animationLoader = animationLoader;
        this.options = null;
        this.containerClass = null;
        this.styles = null;
        this.width = null;
        this.height = null;
        /**
         * `animationCreated` is dispatched after calling `loadAnimation`
         */
        this.animationCreated = new EventEmitter();
        /**
         * `complete` is dispatched after completing the last frame
         */
        this.complete = new EventEmitter();
        /**
         * `loopComplete` is dispatched after completing frame loop
         */
        this.loopComplete = new EventEmitter();
        /**
         * `enterFrame` is dispatched after entering the new frame
         */
        this.enterFrame = new EventEmitter();
        /**
         * `segmentStart` is dispatched when the new segment is adjusted
         */
        this.segmentStart = new EventEmitter();
        /**
         * Original event name is `config_ready`. `config_ready` is dispatched
         * after the needed renderer is configured
         */
        this.configReady = new EventEmitter();
        /**
         * Original event name is `data_ready`. `data_ready` is dispatched
         * when all parts of the animation have been loaded
         */
        this.dataReady = new EventEmitter();
        /**
         * Original event name is `DOMLoaded`. `DOMLoaded` is dispatched
         * when elements have been added to the DOM
         */
        this.domLoaded = new EventEmitter();
        /**
         * `destroy` will be dispatched in the `ngOnDestroy` hook of the service,
         * it's useful for releasing resources
         */
        this.destroy = new EventEmitter();
        /**
         * `error` will be dispatched if the lottie player could not render
         * some frame or parse config
         */
        this.error = new EventEmitter();
        this.destroy$ = new Subject();
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }
    /**
     * @protected
     * @return {?}
     */
    setWidthAndHeight() {
        this.width = this.width || '100%';
        this.height = this.height || '100%';
    }
    /**
     * @protected
     * @param {?} container
     * @param {?} eventsFacade
     * @param {?} instance
     * @return {?}
     */
    loadAnimation(container, eventsFacade, instance) {
        if (isPlatformServer(this.platformId)) {
            return;
        }
        this.animationLoader.resolveLoaderAndLoadAnimation(this.options, container, eventsFacade, this.animationCreated, instance, this.destroy$);
    }
}
BaseDirective.ɵfac = function BaseDirective_Factory(t) { return new (t || BaseDirective)(ɵngcc0.ɵɵdirectiveInject(PLATFORM_ID), ɵngcc0.ɵɵdirectiveInject(AnimationLoader)); };
BaseDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: BaseDirective, selectors: [["", "lottie", ""]], inputs: { options: "options", containerClass: "containerClass", styles: "styles", width: "width", height: "height" }, outputs: { animationCreated: "animationCreated", complete: "complete", loopComplete: "loopComplete", enterFrame: "enterFrame", segmentStart: "segmentStart", configReady: "configReady", dataReady: "dataReady", domLoaded: "domLoaded", destroy: "destroy", error: "error" } });
/** @nocollapse */
BaseDirective.ctorParameters = () => [
    { type: String, decorators: [{ type: Inject, args: [PLATFORM_ID,] }] },
    { type: AnimationLoader }
];
BaseDirective.propDecorators = {
    options: [{ type: Input }],
    containerClass: [{ type: Input }],
    styles: [{ type: Input }],
    width: [{ type: Input }],
    height: [{ type: Input }],
    animationCreated: [{ type: Output }],
    complete: [{ type: Output }],
    loopComplete: [{ type: Output }],
    enterFrame: [{ type: Output }],
    segmentStart: [{ type: Output }],
    configReady: [{ type: Output }],
    dataReady: [{ type: Output }],
    domLoaded: [{ type: Output }],
    destroy: [{ type: Output }],
    error: [{ type: Output }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BaseDirective, [{
        type: Directive,
        args: [{ selector: '[lottie]' }]
    }], function () { return [{ type: String, decorators: [{
                type: Inject,
                args: [PLATFORM_ID]
            }] }, { type: AnimationLoader }]; }, { options: [{
            type: Input
        }], containerClass: [{
            type: Input
        }], styles: [{
            type: Input
        }], width: [{
            type: Input
        }], height: [{
            type: Input
        }], animationCreated: [{
            type: Output
        }], complete: [{
            type: Output
        }], loopComplete: [{
            type: Output
        }], enterFrame: [{
            type: Output
        }], segmentStart: [{
            type: Output
        }], configReady: [{
            type: Output
        }], dataReady: [{
            type: Output
        }], domLoaded: [{
            type: Output
        }], destroy: [{
            type: Output
        }], error: [{
            type: Output
        }] }); })();
if (false) {
    /** @type {?} */
    BaseDirective.prototype.options;
    /** @type {?} */
    BaseDirective.prototype.containerClass;
    /** @type {?} */
    BaseDirective.prototype.styles;
    /** @type {?} */
    BaseDirective.prototype.width;
    /** @type {?} */
    BaseDirective.prototype.height;
    /**
     * `animationCreated` is dispatched after calling `loadAnimation`
     * @type {?}
     */
    BaseDirective.prototype.animationCreated;
    /**
     * `complete` is dispatched after completing the last frame
     * @type {?}
     */
    BaseDirective.prototype.complete;
    /**
     * `loopComplete` is dispatched after completing frame loop
     * @type {?}
     */
    BaseDirective.prototype.loopComplete;
    /**
     * `enterFrame` is dispatched after entering the new frame
     * @type {?}
     */
    BaseDirective.prototype.enterFrame;
    /**
     * `segmentStart` is dispatched when the new segment is adjusted
     * @type {?}
     */
    BaseDirective.prototype.segmentStart;
    /**
     * Original event name is `config_ready`. `config_ready` is dispatched
     * after the needed renderer is configured
     * @type {?}
     */
    BaseDirective.prototype.configReady;
    /**
     * Original event name is `data_ready`. `data_ready` is dispatched
     * when all parts of the animation have been loaded
     * @type {?}
     */
    BaseDirective.prototype.dataReady;
    /**
     * Original event name is `DOMLoaded`. `DOMLoaded` is dispatched
     * when elements have been added to the DOM
     * @type {?}
     */
    BaseDirective.prototype.domLoaded;
    /**
     * `destroy` will be dispatched in the `ngOnDestroy` hook of the service,
     * it's useful for releasing resources
     * @type {?}
     */
    BaseDirective.prototype.destroy;
    /**
     * `error` will be dispatched if the lottie player could not render
     * some frame or parse config
     * @type {?}
     */
    BaseDirective.prototype.error;
    /**
     * @type {?}
     * @private
     */
    BaseDirective.prototype.destroy$;
    /**
     * @type {?}
     * @private
     */
    BaseDirective.prototype.platformId;
    /**
     * @type {?}
     * @private
     */
    BaseDirective.prototype.animationLoader;
}

/**
 * @fileoverview added by tsickle
 * Generated from: src/animation-cache.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class AnimationCache {
    constructor() {
        this.cache = new Map();
    }
    /**
     * @param {?} options
     * @return {?}
     */
    static create(options) {
        if (options.useCache) {
            return new AnimationCache();
        }
        return null;
    }
    /**
     * @param {?} options
     * @return {?}
     */
    transformOptions(options) {
        /** @type {?} */
        const path = ((/** @type {?} */ (options))).path;
        if (path && this.cache.has(path)) {
            delete ((/** @type {?} */ (options))).path;
            ((/** @type {?} */ (options))).animationData = this.cache.get(path);
        }
        return options;
    }
    /**
     * @param {?} options
     * @param {?} animationItem
     * @return {?}
     */
    set(options, animationItem) {
        if (isAnimationConfigWithData(options)) {
            return;
        }
        /** @type {?} */
        const animationData = animationItem['animationData'];
        this.cache.set((/** @type {?} */ (options.path)), animationData);
    }
}
if (false) {
    /**
     * @type {?}
     * @private
     */
    AnimationCache.prototype.cache;
}

/**
 * @fileoverview added by tsickle
 * Generated from: src/events-facade.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Returns only those `EventEmitter` instances that has attached observers
 * @param {?} instance
 * @param {?} eventsMap
 * @return {?}
 */
function getObservedEventEmitters(instance, eventsMap) {
    return (Object.keys(instance)
        // `Object.entries` is not supported in IE11.
        .map((/**
     * @param {?} key
     * @return {?}
     */
    key => [key, instance[key]]))
        .filter((/**
     * @param {?} __0
     * @return {?}
     */
    ([key, property]) => property instanceof EventEmitter &&
        property.observers.length > 0 &&
        eventsMap.hasOwnProperty(key)))
        .map((/**
     * @param {?} __0
     * @return {?}
     */
    ([key, eventEmitter]) => ({
        eventEmitter,
        name: eventsMap[key]
    }))));
}
class LottieEventsFacade {
    /**
     * @param {?} ngZone
     * @param {?} platformId
     */
    constructor(ngZone, platformId) {
        this.ngZone = ngZone;
        this.platformId = platformId;
        /**
         * @see https://github.com/airbnb/lottie-web#events
         */
        this.eventsMap = {
            complete: 'complete',
            loopComplete: 'loopComplete',
            enterFrame: 'enterFrame',
            segmentStart: 'segmentStart',
            configReady: 'config_ready',
            dataReady: 'data_ready',
            domLoaded: 'DOMLoaded',
            destroy: 'destroy',
            error: 'error'
        };
        this.animationItem = null;
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this.dispose();
    }
    /**
     * @param {?} instance
     * @param {?} animationItem
     * @return {?}
     */
    addEventListeners(instance, animationItem) {
        this.animationItem = animationItem;
        // `AnimationItem` triggers different events every ms, we have to listen
        // them outside Angular's context, thus it won't affect performance
        this.ngZone.runOutsideAngular((/**
         * @return {?}
         */
        () => this.addEventListenersToObservedEventEmitters(instance)));
    }
    /**
     * @private
     * @return {?}
     */
    dispose() {
        // The `ng-lottie` component or the `lottie` directive can be destroyed
        // before the `animationItem` is set, thus it will fail with
        // `Cannot read property 'destroy' of null`.
        // Potentially it can happen if the directive gets destroyed before change
        // detection is run.
        if (isPlatformServer(this.platformId) || this.animationItem === null) {
            return;
        }
        // `destroy()` will remove all events listeners
        this.animationItem.destroy();
        this.animationItem = null;
    }
    /**
     * @private
     * @param {?} instance
     * @return {?}
     */
    addEventListenersToObservedEventEmitters(instance) {
        /** @type {?} */
        const observedEmitters = getObservedEventEmitters(instance, this.eventsMap);
        for (const { name, eventEmitter } of observedEmitters) {
            (/** @type {?} */ (this.animationItem)).addEventListener(name, (/**
             * @param {?} event
             * @return {?}
             */
            (event) => {
                eventEmitter.emit(event);
            }));
        }
    }
}
LottieEventsFacade.ɵfac = function LottieEventsFacade_Factory(t) { return new (t || LottieEventsFacade)(ɵngcc0.ɵɵinject(ɵngcc0.NgZone), ɵngcc0.ɵɵinject(PLATFORM_ID)); };
LottieEventsFacade.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: LottieEventsFacade, factory: LottieEventsFacade.ɵfac });
/** @nocollapse */
LottieEventsFacade.ctorParameters = () => [
    { type: NgZone },
    { type: String, decorators: [{ type: Inject, args: [PLATFORM_ID,] }] }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(LottieEventsFacade, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc0.NgZone }, { type: String, decorators: [{
                type: Inject,
                args: [PLATFORM_ID]
            }] }]; }, null); })();
if (false) {
    /**
     * @see https://github.com/airbnb/lottie-web#events
     * @type {?}
     * @private
     */
    LottieEventsFacade.prototype.eventsMap;
    /**
     * @type {?}
     * @private
     */
    LottieEventsFacade.prototype.animationItem;
    /**
     * @type {?}
     * @private
     */
    LottieEventsFacade.prototype.ngZone;
    /**
     * @type {?}
     * @private
     */
    LottieEventsFacade.prototype.platformId;
}

/**
 * @fileoverview added by tsickle
 * Generated from: src/lottie.directive.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class LottieDirective extends BaseDirective {
    /**
     * @param {?} platformId
     * @param {?} host
     * @param {?} eventsFacade
     * @param {?} animationLoader
     */
    constructor(platformId, host, eventsFacade, animationLoader) {
        super(platformId, animationLoader);
        this.host = host;
        this.eventsFacade = eventsFacade;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        super.loadAnimation(this.host.nativeElement, this.eventsFacade, this);
    }
}
LottieDirective.ɵfac = function LottieDirective_Factory(t) { return new (t || LottieDirective)(ɵngcc0.ɵɵdirectiveInject(PLATFORM_ID), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef, 2), ɵngcc0.ɵɵdirectiveInject(LottieEventsFacade, 2), ɵngcc0.ɵɵdirectiveInject(AnimationLoader)); };
LottieDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: LottieDirective, selectors: [["", "lottie", ""]], features: [ɵngcc0.ɵɵProvidersFeature([LottieEventsFacade]), ɵngcc0.ɵɵInheritDefinitionFeature] });
/** @nocollapse */
LottieDirective.ctorParameters = () => [
    { type: String, decorators: [{ type: Inject, args: [PLATFORM_ID,] }] },
    { type: ElementRef, decorators: [{ type: Self }] },
    { type: LottieEventsFacade, decorators: [{ type: Self }] },
    { type: AnimationLoader }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(LottieDirective, [{
        type: Directive,
        args: [{
                selector: '[lottie]',
                providers: [LottieEventsFacade]
            }]
    }], function () { return [{ type: String, decorators: [{
                type: Inject,
                args: [PLATFORM_ID]
            }] }, { type: ɵngcc0.ElementRef, decorators: [{
                type: Self
            }] }, { type: LottieEventsFacade, decorators: [{
                type: Self
            }] }, { type: AnimationLoader }]; }, null); })();
if (false) {
    /**
     * @type {?}
     * @private
     */
    LottieDirective.prototype.host;
    /**
     * @type {?}
     * @private
     */
    LottieDirective.prototype.eventsFacade;
}

/**
 * @fileoverview added by tsickle
 * Generated from: src/lottie.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class LottieComponent extends BaseDirective {
    /**
     * @param {?} platformId
     * @param {?} eventsFacade
     * @param {?} animationLoader
     */
    constructor(platformId, eventsFacade, animationLoader) {
        super(platformId, animationLoader);
        this.eventsFacade = eventsFacade;
        this.container = (/** @type {?} */ (null));
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        super.setWidthAndHeight();
        super.loadAnimation(this.container.nativeElement, this.eventsFacade, this);
    }
}
LottieComponent.ɵfac = function LottieComponent_Factory(t) { return new (t || LottieComponent)(ɵngcc0.ɵɵdirectiveInject(PLATFORM_ID), ɵngcc0.ɵɵdirectiveInject(LottieEventsFacade, 2), ɵngcc0.ɵɵdirectiveInject(AnimationLoader)); };
LottieComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: LottieComponent, selectors: [["ng-lottie"]], viewQuery: function LottieComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵstaticViewQuery(_c0, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.container = _t.first);
    } }, features: [ɵngcc0.ɵɵProvidersFeature([LottieEventsFacade]), ɵngcc0.ɵɵInheritDefinitionFeature], decls: 2, vars: 6, consts: [[3, "ngStyle", "ngClass"], ["container", ""]], template: function LottieComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelement(0, "div", 0, 1);
    } if (rf & 2) {
        ɵngcc0.ɵɵstyleProp("width", ctx.width)("height", ctx.height);
        ɵngcc0.ɵɵproperty("ngStyle", ctx.styles)("ngClass", ctx.containerClass);
    } }, directives: [ɵngcc1.NgStyle, ɵngcc1.NgClass], encapsulation: 2, changeDetection: 0 });
/** @nocollapse */
LottieComponent.ctorParameters = () => [
    { type: String, decorators: [{ type: Inject, args: [PLATFORM_ID,] }] },
    { type: LottieEventsFacade, decorators: [{ type: Self }] },
    { type: AnimationLoader }
];
LottieComponent.propDecorators = {
    container: [{ type: ViewChild, args: ['container', { static: true },] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(LottieComponent, [{
        type: Component,
        args: [{
                selector: 'ng-lottie',
                template: `
    <div
      #container
      [style.width]="width"
      [style.height]="height"
      [ngStyle]="styles"
      [ngClass]="containerClass"
    ></div>
  `,
                changeDetection: ChangeDetectionStrategy.OnPush,
                providers: [LottieEventsFacade]
            }]
    }], function () { return [{ type: String, decorators: [{
                type: Inject,
                args: [PLATFORM_ID]
            }] }, { type: LottieEventsFacade, decorators: [{
                type: Self
            }] }, { type: AnimationLoader }]; }, { container: [{
            type: ViewChild,
            args: ['container', { static: true }]
        }] }); })();
if (false) {
    /** @type {?} */
    LottieComponent.prototype.container;
    /**
     * @type {?}
     * @private
     */
    LottieComponent.prototype.eventsFacade;
}

/**
 * @fileoverview added by tsickle
 * Generated from: src/lottie.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class LottieModule {
    /**
     * @param {?} options
     * @return {?}
     */
    static forRoot(options) {
        return {
            ngModule: LottieModule,
            providers: [
                AnimationLoader,
                {
                    provide: LOTTIE_OPTIONS,
                    useValue: options
                },
                {
                    provide: IS_SAFARI,
                    useFactory: isSafariFactory
                },
                {
                    provide: ANIMATION_CACHE,
                    useFactory: AnimationCache.create,
                    deps: [LOTTIE_OPTIONS]
                }
            ]
        };
    }
}
LottieModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: LottieModule });
LottieModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function LottieModule_Factory(t) { return new (t || LottieModule)(); }, imports: [[CommonModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(LottieModule, { declarations: function () { return [BaseDirective, LottieDirective, LottieComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [BaseDirective, LottieDirective, LottieComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(LottieModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule],
                declarations: [BaseDirective, LottieDirective, LottieComponent],
                exports: [BaseDirective, LottieDirective, LottieComponent]
            }]
    }], null, null); })();

/**
 * @fileoverview added by tsickle
 * Generated from: src/transfer-state.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class LottieTransferState {
    /**
     * @param {?} transferState
     */
    constructor(transferState) {
        this.transferState = transferState;
    }
    /**
     * @template T
     * @param {?} animation
     * @return {?}
     */
    get(animation) {
        /** @type {?} */
        const animationKey = transformAnimationFilenameToKey(animation);
        /** @type {?} */
        const stateKey = makeStateKey(animationKey);
        return this.transferState.get(stateKey, null);
    }
}
LottieTransferState.ɵfac = function LottieTransferState_Factory(t) { return new (t || LottieTransferState)(ɵngcc0.ɵɵinject(ɵngcc2.TransferState)); };
/** @nocollapse */
LottieTransferState.ctorParameters = () => [
    { type: TransferState }
];
/** @nocollapse */ LottieTransferState.ɵprov = ɵɵdefineInjectable({ factory: function LottieTransferState_Factory() { return new LottieTransferState(ɵɵinject(TransferState)); }, token: LottieTransferState, providedIn: "root" });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(LottieTransferState, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: ɵngcc2.TransferState }]; }, null); })();
if (false) {
    /**
     * @type {?}
     * @private
     */
    LottieTransferState.prototype.transferState;
}

/**
 * @fileoverview added by tsickle
 * Generated from: src/public_api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: ngx-lottie.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { BaseDirective, LottieComponent, LottieDirective, LottieModule, LottieTransferState, transformAnimationFilenameToKey, IS_SAFARI as ɵb, LOTTIE_OPTIONS as ɵc, ANIMATION_CACHE as ɵd, isSafariFactory as ɵe, AnimationLoader as ɵf, AnimationCache as ɵg, LottieEventsFacade as ɵh };

//# sourceMappingURL=ngx-lottie.js.map